// @flow

import styles from './Search.less';

import React from 'react';
import { connect } from 'react-redux';
import { provideHooks } from 'redial';
import classnames from 'classnames';
import { renderRoutes } from 'react-router-config';
import { isSearchResultsPath } from '@seek/seek-jobs-seo';

import SearchBar from './SearchBar/SearchBar';
import RefineBar from './RefineBar/RefineBar';
import ContentSpacer from 'src/components/ContentSpacer/ContentSpacer';
import SaveSearchPrompt from 'src/components/SaveSearchPrompt/SaveSearchPrompt';
import StickySerpElement from 'src/components/StickySerpElement/StickySerpElement';
import Sticky from 'react-sticky-el';

import { updateCriteria, getCounts } from 'src/store/search/search';
import { states } from 'src/store/saveSearch/saveSearch';

import { isMobileUserAgent } from 'src/modules/chalice-user-agent/device-detect';

const hooks = {
  first({ dispatch, path, query }) {
    return dispatch(updateCriteria({ path, query }));
  },
  defer({ dispatch, locale, path, query, cookies }) {
    return dispatch(getCounts({ locale, path, query, cookies }));
  }
};

function mapStateToProps({ user, location, results, saveSearch }) {
  return {
    isHomepage: location.isHomepage,
    pathname: location.pathname,
    resultsHidden: results.hidden,
    authenticated: user.authenticated,
    isSearchSaved: saveSearch.isSaved,
    savingStatus: saveSearch.status
  };
}

type Props = {
  authenticated: boolean,
  isHomepage: boolean,
  route: Object,
  experiments?: Object,
  pathname: string,
  resultsHidden: boolean,
  isSearchSaved?: boolean,
  savingStatus?: string
};

const Search = ({
  authenticated,
  isHomepage,
  route,
  pathname,
  resultsHidden,
  isSearchSaved,
  savingStatus
}: Props) => {
  const filterClasses = classnames({
    [styles.filters]: true,
    [styles.filters_isExpanded]: isHomepage
  });

  const isJustSaved = savingStatus === states.SAVED;

  const showStickySaveSearchPrompt =
    isSearchResultsPath(pathname) &&
    !resultsHidden &&
    authenticated &&
    (!isSearchSaved || isJustSaved);

  return (
    <div className={styles.root}>
      <div className={filterClasses}>
        <SearchBar collapsed={!isHomepage} />
        <RefineBar expanded={!isHomepage} />
      </div>

      {showStickySaveSearchPrompt && !isMobileUserAgent() && (
        <StickySerpElement target="sticky-save-search-desktop" topOffset={190}>
          <SaveSearchPrompt
            isSearchSaved={isSearchSaved}
            className={styles.topStickyPromptShadow}
          />
        </StickySerpElement>
      )}

      <ContentSpacer isSlider trigger={['searchbar', 'refinebar']}>
        {renderRoutes(route.routes)}
      </ContentSpacer>

      {showStickySaveSearchPrompt && isMobileUserAgent() && (
        <div className={styles.stickySaveSearchBottom}>
          <Sticky mode="bottom">
            <SaveSearchPrompt
              isSearchSaved={isSearchSaved}
              className={styles.bottomStickyPromptShadow}
            />
          </Sticky>
        </div>
      )}
    </div>
  );
};

export default provideHooks(hooks)(connect(mapStateToProps)(Search));
